import { Injectable } from '@angular/core';
// import { Headers, Http } from '@angular/http';

import { Http } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import'rxjs/add/operator/toPromise';
import'rxjs/add/operator/catch';
import'rxjs/add/operator/map';
import'rxjs/add/operator/concatMap';
import'rxjs/add/operator/filter';
import'rxjs/add/operator/reduce';

import { ConfigService } from '../config/config.service';
import { State } from './state';
export class StatesService {
    title = 'State Service';
private stateUrl = '';
private config: any;
private states: Observable<State[]>;
/**
 * @param {?} http
 * @param {?} configService
 */
constructor(
private http: Http,
private configService: ConfigService
    ) {
        this.configService.getConfig((configuration:any) => {
            this.config = configuration;
            this.stateUrl = this.config.baseUrl + '/states';

            this.getStates();
        });
    }
/**
 * @return {?}
 */
getStates(): Observable<State[]> {

        this.states = this.http.get(this.stateUrl).map(res => res.json());
        
        return this.states;
    }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: ConfigService, },
];
}

function StatesService_tsickle_Closure_declarations() {
/** @type {?} */
StatesService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StatesService.ctorParameters;
/** @type {?} */
StatesService.prototype.title;
/** @type {?} */
StatesService.prototype.stateUrl;
/** @type {?} */
StatesService.prototype.config;
/** @type {?} */
StatesService.prototype.states;
/** @type {?} */
StatesService.prototype.http;
/** @type {?} */
StatesService.prototype.configService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
